module.exports = __webpack_public_path__ + "assets/media/s33.88cd0d9b.mp3";